import * as persistenceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';

import { AIRPORT_FILTER_CHANGED, FILTERS_RESET } from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  AirportsFilterState,
  AirportsFilterEntry,
} from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/airports';
import type { EntityId } from '@web-platform/shared-universal-types-utils/src/utils';

const INITIAL_STATE = {};

const isEntityIdKey = (key: string): key is EntityId => /^\d+$/.test(key);

const filtersInSession = (): { airports?: Record<string, AirportsFilterEntry> } | undefined =>
  tryGetValue(persistenceKeys.FILTERS, INITIAL_STATE);

const storedStateFilters = (): AirportsFilterState => {
  const sessionFilters = filtersInSession();
  if (!sessionFilters?.airports) return INITIAL_STATE;

  const filtered: AirportsFilterState = {};
  for (const [key, entry] of Object.entries(sessionFilters.airports)) {
    if (isEntityIdKey(key)) {
      filtered[key] = entry;
    }
  }
  return filtered;
};

const airportsFilterReducer = (
  state: AirportsFilterState = storedStateFilters(),
  action: Action,
): AirportsFilterState => {
  switch (action.type) {
    case AIRPORT_FILTER_CHANGED:
      return {
        ...state,
        [action.payload.entityId]: {
          entityId: action.payload.entityId,
          skyNodeCode: action.payload.skyNodeCode,
          value: action.payload.value,
        },
      };

    case FILTERS_RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export const get = (state: AirportsFilterState) => state;
export default airportsFilterReducer;
